import React from 'react';

import PropTypes from 'prop-types';

import { Container } from './css';
import Navigation from './components/navigation';
import Dealership from './components/dealership';
import DomainWhitelist from './components/domainWhitelist';
import FormFreeze from './components/formFreeze';
import Channels from './components/channels';
import Outlets from './components/outlets';

const ManageControl = ({ match: { params } }) => {
  const { tabName } = params;
  const selectedDashboard = tabName;

  return (
    <Container>
      <Navigation selectedDashboard={selectedDashboard} />
      {selectedDashboard === 'dealerships' && <Dealership />}
      {selectedDashboard === 'domainsWhitelist' && <DomainWhitelist />}
      {selectedDashboard === 'formFreeze' && <FormFreeze />}
      {selectedDashboard === 'channels' && <Channels />}
      {selectedDashboard === 'outlets' && <Outlets />}
    </Container>
  );
};

ManageControl.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      tabName: PropTypes.string
    })
  }).isRequired
};

export default ManageControl;
